export const BASE =
    process.env.NODE_ENV === 'production' ? '//drippy.up.railway.app' : '';
